import React from "react";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Chat } from "@material-ui/icons";
import { BodyStyled, CardStyle, TitleStyled } from "./styles";
import { useSelector } from "react-redux";

export default function Dashboard() {
  const token = useSelector((state) => state.login.token);
  const rules = useSelector((state) => state.login.rules);
  
  const onClick = () => {
    window.open(
      `${process.env.REACT_APP_CHAT_URL}auth/chat/${token}`,
      '_blank'
    );
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <h1>Bienvenido</h1>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} md={3}>
          {rules && rules.includes("CHAT") ? (
            <CardStyle onClick={() => onClick()}>
              <BodyStyled>
                <Chat />
                <TitleStyled>Chat</TitleStyled>
              </BodyStyled>
            </CardStyle>
          ) : null}
        </GridItem>
      </GridContainer>
    </div>
  );
}
